import type { StockPolicyItemType } from "@/modules/inventory/domain/types";

export const STOCK_POLICY_MENU_TITLE = "ເງື່ອນໄຂສຕັອກ";

export function stockPolicyItemTypeLabel(
  itemType: StockPolicyItemType,
): string {
  return itemType === "INGREDIENT" ? "ວັດຖຸດິບ" : "ຕົວແບບສິນຄ້າ";
}

export function stockPolicyScopeLabel(
  branchId: string | null,
  branchCode: string | null,
): string {
  if (!branchId) return "ທົ່ວໄປ (Global)";
  return branchCode ? `ສາຂາ ${branchCode}` : "ສາຂາ";
}
